import { Box } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { DataGridText, ScammersLibraryText } from "../../data/texts";
import { Scammer } from "../../models/scammers-library.model";
import CustomTable, { PaginationModel } from "../common/CustomTable";
import CustomPaginationSlot from "./CustomPaginationSlot";

interface ScammersLibraryTableProps {
  scammers: Scammer[];
  totalScammersNumber: number;
  onPaginationModelChange: (model: PaginationModel) => void;
  isLoading: boolean;
  page: number;
}

const ScammersLibraryTable = ({
  scammers,
  isLoading,
  page,
  onPaginationModelChange,
  totalScammersNumber,
}: ScammersLibraryTableProps) => {
  const tableColumns: GridColDef[] = [
    {
      field: "id",
      headerName: "ID",
      width: 90,
      cellClassName: "id-column",
    },
    {
      flex: 1,
      minWidth: 200,
      field: "name",
      headerName: "Name",
    },
    {
      minWidth: 300,
      flex: 2,
      field: "url",
      headerName: "URL",
    },
    {
      minWidth: 150,
      flex: 2,
      field: "database",
      headerName: "Database",
    },
  ];

  const onPageChange = (page: number) => {
    onPaginationModelChange({ pageSize: 7, page });
  };

  return (
    <Box>
      {scammers && (
        <CustomTable
          slots={{ pagination: CustomPaginationSlot }}
          slotProps={{
            pagination: { handlePageChange: onPageChange, page },
          }}
          page={page}
          isLoading={isLoading}
          onPaginationModelChange={onPaginationModelChange}
          localeText={DataGridText.NO_SCAMMERS}
          totalRowNumber={totalScammersNumber}
          tableRows={scammers}
          tableColumns={tableColumns}
          title={ScammersLibraryText.SCAMMERS_LIBRARY}
        />
      )}
    </Box>
  );
};

export default ScammersLibraryTable;
